module.exports = __webpack_public_path__ + "media/images/red_light_hover-27ef69f15dadf7e5ab27da7b2dca8f8b.jpg";